import { BreakpointObserver } from "@angular/cdk/layout";
import { inject, Injectable } from "@angular/core";

export const DIALOG_SIZES = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
} as const;

export type Size = typeof DIALOG_SIZES[keyof typeof DIALOG_SIZES];

interface Config {
    minWidth: string;
    minHeight: string;
}

const MOBILE_CONFIG: Record<Size, Config> = {
    [DIALOG_SIZES.SMALL]: {
        minWidth: '90vw',
        minHeight: '60vh'
    },
    [DIALOG_SIZES.MEDIUM]: {
        minWidth: '90vw',
        minHeight: '60vh'
    },
    [DIALOG_SIZES.LARGE]: {
        minWidth: '90vw',
        minHeight: '60vh'
    }
};

const DESKTOP_CONFIG: Record<Size, Config> = {
    [DIALOG_SIZES.SMALL]: {
        minWidth: '20vw',
        minHeight: '20vh'
    },
    [DIALOG_SIZES.MEDIUM]: {
        minWidth: '40vw',
        minHeight: '40vh'
    },
    [DIALOG_SIZES.LARGE]: {
        minWidth: '60vw',
        minHeight: '60vh'
    }
};

@Injectable({
    providedIn: 'root'
})
export class DialogConfig {

    private observer = inject(BreakpointObserver);

    config(size: Size): Config {
        const isMobile = this.observer.isMatched('(max-width: 600px)');
        const config = isMobile ? MOBILE_CONFIG : DESKTOP_CONFIG;
        return config[size];
    }
}